import React, { useEffect, useState } from "react";
import { region, getUserOrgs } from "../utilities/genesysCloudUtils";
import { ENV } from "../config/clientConfig";
import "../App.css";

const { redirect, cac1 } = ENV;

const simplifyOrgName = (orgName) => {
  if (orgName === "Maximus Canada DEV" || orgName === "maximuscanada-dev")
    return "DEV";
  if (orgName === "Maximus Canada FEC" || orgName === "maximuscanada-fec")
    return "FEC";
  if (
    orgName === "Maximus Canada SBC Internal CC" ||
    orgName === "maximuscanada-sbc-internalcc"
  )
    return "ICC";
  if (orgName === "Maximus Canada Service Desk" || orgName === "maximuscanada-servicedesk")
    return "MAX";
  if (orgName === "Maximus Canada ODB" || orgName === "maximuscanada-odb")
    return "ODB";
  if (orgName === "Maximus Canada" || orgName === "maximuscanada") return "SBC";
  if (
    orgName === "Maximus Canada SBC SDO" ||
    orgName === "maximuscanada-sbc-sdo"
  )
    return "SDO";
  if (
    orgName === "Maximus Canada Service Timmins" ||
    orgName === "maximuscanada-service-timmins"
  )
    return "TIM";
};

export function Org({ setOrg }) {
  const storedTrustors = JSON.parse(localStorage.getItem("trustors"));
  const [userOrg, setUserOrg] = useState();
  const [home, setHome] = useState({ organization: cac1.DEV });
  const [trustors, setTrustors] = useState(
    !storedTrustors ? [home] : storedTrustors
  );

  useEffect(() => {
    getUserOrgs().then((data) => {
      setOrg(simplifyOrgName(data.organization.name));
      setUserOrg(data);
      if (data.organization.id === cac1.DEV.id)
        return localStorage.setItem(
          "trustors",
          // JSON.stringify(data.trustors.concat(home))
          data.trustors
            ? JSON.stringify(data.trustors.concat(home))
            : JSON.stringify(home)
        );
    });
  }, [home, trustors]);

  const switchOrg = (orgId, clientId) => {
    let redirectURL = `https://login.${region}/oauth/authorize?client_id=${clientId}&response_type=token&state=${region}&redirect_uri=${redirect}&target=${orgId}`;
    return redirectURL;
  };

  return (
    <>
      {userOrg ? (
        <>
          <div>
            {trustors.length &&
              userOrg.token.homeOrganization.id === home.organization.id && (
                <div>
                  <span className="font-semibold">Org Switcher: </span>
                  {console.log("TRUSTORS", trustors)}
                  {trustors.length &&
                    trustors
                      .sort((a, b) =>
                        simplifyOrgName(a.organization.name).localeCompare(
                          simplifyOrgName(b.organization.name)
                        )
                      )
                      .map((trustor, index) => {
                        return (
                          <span
                            key={index}
                            className={
                              userOrg.organization.id ===
                              trustor.organization.id
                                ? ""
                                : ""
                            }
                          >
                            <a
                              href={switchOrg(
                                trustor.organization.id,
                                cac1[simplifyOrgName(trustor.organization.name)]
                                  .clientId
                              )}
                            >
                              {trustors.length === 1
                                ? "REFRESH"
                                : simplifyOrgName(
                                    trustor.organization.name
                                  )}{" "}
                            </a>
                          </span>
                        );
                      })}
                </div>
              )}
          </div>
          <div className="card-body p-2">
            <span>{userOrg.name}</span>
            {/* <kbd className="kbd">{userOrg.id}</kbd> */}
            <span>{userOrg.organization.name}</span>
            {/* <kbd className="kbd">{userOrg.organization.id}</kbd> */}
          </div>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </>
  );
}
